export const FETCH_RANDOM_REQUEST='FETCH_RANDOM_REQUEST'
export const FETCH_RANDOM_SUCCESS='FETCH_RANDOM_SUCCESS'
export const FETCH_RANDOM_FAILURE='FETCH_RANDOM_FAILURE'